// Registro global de trabajo en curso (consultas GraphQL y módulos diferidos)
// para que la carga entre módulos sepa cuándo la pantalla nueva está lista.
const pendingTasks = { query: 0, suspense: 0 };
const listeners = new Set();
let isNotifyScheduled = false;

// Las consultas de Apollo pueden iniciarse durante el render de otro
// componente; se notifica fuera de ese ciclo para no actualizar estado ajeno.
const scheduleNotify = () => {
  if (isNotifyScheduled) return;
  isNotifyScheduled = true;

  Promise.resolve().then(() => {
    isNotifyScheduled = false;
    const snapshot = getPendingTasks();
    listeners.forEach((listener) => listener(snapshot));
  });
};

export const getPendingTasks = () => ({ ...pendingTasks });

export const beginPendingTask = (kind) => {
  pendingTasks[kind] += 1;
  scheduleNotify();
  let isFinished = false;

  return () => {
    if (isFinished) return;
    isFinished = true;
    pendingTasks[kind] -= 1;
    scheduleNotify();
  };
};

export const subscribePendingTasks = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
